import ToteumatPage from './Components/ToteumatPage'

export default ToteumatPage
